import { mapGetters, mapMutations } from 'vuex';

// FlashCardExerciseTypeMixin
export const FlashCardFilterCheckMixin = {
  name: 'FlashCardFilterCheckMixin',

  computed: {
    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_flashCardFilter: 'flashCardFilter',
      mg_checkedFilterReadingIds: 'checkedFilterReadingIds',
      mg_checkedFilterReadingCardAmount: 'checkedFilterReadingCardAmount',
    }),

    c_cardExerciseType_k() {
      let cardExerciseType_k = '';
      if (this.c_isSequenceFlashCardExerciseType) {
        cardExerciseType_k = 'isSeqSeleted';
      } else if (this.c_isRandomFlashCardExerciseType) {
        cardExerciseType_k = 'isRanSeleted';
      }
      return cardExerciseType_k;
    },

    c_flashCardFilter() {
      return this.mg_flashCardFilter(this.c_cardExerciseType_k);
    },

    c_checkedFilterReadingIds() {
      return this.mg_checkedFilterReadingIds(this.c_cardExerciseType_k);
    },

    c_isNoReadingChecked() {
      return 0 === this.c_checkedFilterReadingIds.length;
    },

    c_isAllReadingChecked() {
      return this.c_checkedFilterReadingIds.length === this.c_flashCardFilter.length;
    },

    c_checkedFilterReadingCardAmount() {
      return this.mg_checkedFilterReadingCardAmount(this.c_cardExerciseType_k);
    },
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_TOGGLE_ALL_FILTER_READING: 'TOGGLE_ALL_FILTER_READING',
      mm_CHECK_FILTER_READING: 'CHECK_FILTER_READING',
    }),

    toggleAllReadings() {
      this.mm_TOGGLE_ALL_FILTER_READING({
        k: this.c_cardExerciseType_k,
        isCheck: !this.c_isAllReadingChecked,
      });
    },

    unCheckAllReadings() {
      this.mm_TOGGLE_ALL_FILTER_READING({
        k: this.c_cardExerciseType_k,
        isCheck: false,
      });
    },

    checkFilterReading(readingId) {
      this.mm_CHECK_FILTER_READING({
        k: this.c_cardExerciseType_k,
        readingId,
      });
    },
  },
};
